import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UploadProfilePictureComponent} from './upload-profile-picture.component';
import {NgxDropzoneModule} from 'ngx-dropzone';

@NgModule({
    declarations: [
        UploadProfilePictureComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDropzoneModule,
        MatButtonModule
    ],
    providers: [],
    exports: [
        UploadProfilePictureComponent
    ]
})

export class UploadProfilePictureModule {
}
